import { FC, useCallback } from "react"
import { InventoryListPanel } from "@/modals/constructor/inventory/InventoryModal/ui/InventoryListPanel"
import { PaperDoll } from "@/ui/PaperDoll"
import styles from "./EquipmentTab.module.scss"
import { IEquipmentTabProps } from "./types"

export const EquipmentTab: FC<IEquipmentTabProps> = ({
  view,
  layoutOrder,
  weight,
  query,
  ctx,
  onQueryChange,
  onItemClick
}) => {
  const { slotsByPosition } = view
  const openSlotItem = useCallback(
    (position: string) => {
      const item = slotsByPosition[position]
      if (item) {
        onItemClick(item)
      }
    },
    [slotsByPosition, onItemClick]
  )

  return (
    <div className={styles.EquipmentTab}>
      <PaperDoll
        layout={layoutOrder}
        itemsByPosition={slotsByPosition}
        onSlotClick={openSlotItem}
      />

      <InventoryListPanel
        items={view.equipmentList}
        weight={weight}
        query={query}
        ctx={ctx}
        onQueryChange={onQueryChange}
        onItemClick={onItemClick}
      />
    </div>
  )
}
